// extracted by mini-css-extract-plugin
export default {"overlay":"Qu-z","bodyOpen":"Ru-z","content":"Su-z","header":"Tu-z","close":"Uu-z","closeNoHeading":"Vu-z"};